export default function DeleteStory({ isOpen, onClose, onDelete }) {
  if (!isOpen) return null;

  return (
    <div onClick={onClose} className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50">

      <div onClick={(e) => e.stopPropagation()} className="bg-[#0e0e0e] w-[90%] md:w-[400px] rounded-2xl p-6 shadow-xl">

        {/* Delete Story Button */}
        <button
          onClick={onDelete}
          className="w-full bg-red-500 hover:bg-red-500 text-white font-semibold text-lg py-3 rounded-full transition"
        >
          Delete Story
        </button>

        {/* Cancel */}
        <button
          onClick={onClose}
          className="w-full mt-4 text-white font-semibold text-lg py-2 hover:opacity-70 transition"
        >
          Cancel
        </button>

      </div>

    </div>
  );
}